export function identifyPrizeConsumer({ campaignId, consumerCpf } = {}) {
  return {
    type: 'prize/IDENTIFY_CONSUMER',
    payload: { campaignId, consumerCpf }
  }
}

export function resolvePrizeIdentification({ consumer, error } = {}) {
  return {
    type: 'prize/RESOLVE_IDENTIFICATION',
    payload: { consumer, error }
  }
}

export function resetPrizeIdentification() {
  return {
    type: 'prize/RESET_IDENTIFICATION'
  }
}

export function registerPrizeConsumer({ campaignId, consumer } = {}) {
  return {
    type: 'prize/REGISTER_CONSUMER',
    payload: { campaignId, consumer }
  }
}

export function resolvePrizeRegistration({ consumer, error } = {}) {
  return {
    type: 'prize/RESOLVE_REGISTRATION',
    payload: { consumer, error }
  }
}
